import React, {memo, useMemo} from "react";

// Utils
import wrapTags from 'utils/wrapTags';


const urlRegex = /(https?:\/\/[^\s]+)/g;

const TextWithLinks = ({children, ignoreLast = false, as = 'p', ...props}) => {
    const content = useMemo(() => {
        if (typeof children !== 'string') {
            return children;
        }

        return wrapTags(children, urlRegex, {
            ignoreLast,
        });
    }, [children]);

    if (as === 'li') {
        return (
            <li {...props}>
                {content}
            </li>
        );
    }

    if (as === 'h3') {
        return (
            <h3 {...props}>
                {content}
            </h3>
        );
    }

    if (as === 'h2') {
        return (
            <h2 {...props}>
                {content}
            </h2>
        );
    }

    if (as === 'span') {
        return (
            <span {...props}>
                {content}
            </span>
        );
    }

    return (
        <p {...props}>
            {content}
        </p>
    );
};

export default memo(TextWithLinks);
